<template>
  <div>
    <b-row>
      <div class="classRow">
        <Title captionTab="Характеристики ЕКП" id="title" class="my-1"/>
      </div>
    </b-row>
    <b-row class="mt-2">
      <b-col>
        <b-input-group prepend="Характеристика" size="sm">
          <b-form-select v-model="selectedType" :options="typeList">
            <template v-slot:first>
              <option :value="null" disabled>-- Выберите тип характеристик --</option>
            </template>
          </b-form-select>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <SpravTab
            :items="items"
            :columns="columns"
            :captionTab="captiontable"
            :isCalled="false"
            :selectedValue="selectedItem"
            @editItem="showEditDialog"
            @updateData="loadItems"
            v-model="selectedItem"
            :captionSpr="captionSport"
            :urls="urls"
            :showCaption=false
            ref="SportTab"
        >
        </SpravTab>
      </b-col>
    </b-row>

    <b-modal ref="editModal" v-model="modalEditOpened" title="Редактирование характеристики" size="lg" hide-footer
             id="editModal">
      <div class="d-block">

        <b-input-group prepend="Код" class="mt-2" size="sm">
          <b-form-input type="text" placeholder="Укажите код"
                        v-model="selectedItem.code"/>
        </b-input-group>

        <b-input-group prepend="Наименование" class="mt-2" size="sm">
          <b-form-input type="text" placeholder="Укажите наименование"
                        :state="nameState"
                        v-model="nameItem"/>
        </b-input-group>
        <b-form-invalid-feedback :state="validValue.name" class="mt-0 mb-2">Указано пустое наименование
        </b-form-invalid-feedback>

        <b-input-group prepend="Краткое наименование" class="mt-2" size="sm">
          <b-form-input type="text" placeholder="Укажите краткое наименование"
                        :state="shortNameState"
                        v-model="shortName"/>
        </b-input-group>
        <b-form-invalid-feedback :state="validValue.shortname" class="mt-0 mb-2">Краткое наименование должно
          быть менее 20 символов
        </b-form-invalid-feedback>

        <b-input-group prepend="Описание" class="mt-2" size="sm">
          <b-form-input type="text" placeholder="Укажите описание"
                        v-model="selectedItem.description"/>
        </b-input-group>

        <b-form-checkbox class="mt-2" v-if="showOtherSett" v-model="selectedItem.viewOnSite">
          Отображать информацию на странице Сайта
        </b-form-checkbox>
      </div>
      <div class="text-right">
        <b-button size="sm" class="mt-1 mr-1" variant="outline-primary" @click="saveSport">Сохранить</b-button>
        <b-button size="sm" class="mt-1" variant="outline-danger" @click="modalEditOpened=!modalEditOpened">Отменить
        </b-button>
      </div>
    </b-modal>

  </div>
</template>

<script>
import SpravTab from '@/components/TabSpr.vue'
import http from '@/http-common'
import Title from '../components/TitlePage'

export default {
  name: 'WorkKind',
  components: {SpravTab, Title},
  data() {
    return {
      selectedType: null,
      captiontable: 'Справочник характеристик ЕКП',
      items: [],
      editItem: {},
      urls: {
        save: '/workkind/save',
        delete: '/workkind',
      },
      captionSport: {
        name: 'Характеристика ЕКП',
        nameR: 'характеристики  ЕКП'
      },
      typeList: [],
      columns: [
        {key: 'typeName', label: 'Тип'},
        {key: 'code', label: 'Код'},
        {key: 'name', label: 'Наименование'},
        {key: 'shortName', label: 'Краткое наименование'},
        {key: 'description', label: 'Описание'},
        {key: 'edit_field', label: '', class: 'width10'}
      ],
      selectedItem: {id: 0, name: '', shortName: ''},
      modalEditOpened: false,
      validValue: {
        name: true,
        type: true,
        shortname: true,
        form: true,
      },
      shortName: '',
      nameItem: '',
      showOtherSett: false
    }
  },
  created() {
    this.loadTypes();
    //this.loadItems();
  },
  watch: {
    shortName: function (val) {
      this.selectedItem.shortName = val;
    },
    nameItem: function (val) {
      this.selectedItem.name = val;
    },
    selectedType: function (val) {
      this.loadItems()
    }
  },
  computed: {
    shortNameState() {
      return !!(this.shortName && this.shortName.length > 0 && this.shortName.length <= 20)
    },
    nameState() {
      return !!(this.nameItem && this.nameItem.length > 0 && this.nameItem.length <= 100)
    }
  },
  methods: {
    checkForm() {
      for (var key in this.validValue) {
        this.validValue[key] = true;
      }
//          if (!this.selectedItem.type || this.selectedItem.type == '') {
//              this.validValue.type = false;
//              this.validValue.form = false;
//          }
      if (this.selectedItem.shortName && this.selectedItem.shortName.length > 20) {
        this.validValue.shortname = false;
        this.validValue.form = false;
      }
      if (!this.selectedItem.name || this.selectedItem.name == '') {
        this.validValue.name = false;
        this.validValue.form = false;
      }
    },
    loadTypes() {
      var vm = this;
      http.get('/workkind/types')
      .then((response) => {
        vm.typeList = response.data;
        vm.selectedType = response.data[0].value;
      })
      .catch((error) => console.log(error.response.data));
    },
    loadItems() {
      var vm = this;
      var ls = vm.typeList.filter(function (x) {
        return x.value == vm.selectedType;
      });
      vm.showOtherSett = ls[0].code == "true" ? true : false;

      http.get('/workkind/' + this.selectedType + '/list')
      .then((response) => {
        vm.items = response.data;
      })
      .catch((error) => console.log(error.response.data));
    },
    showEditDialog() {
      this.shortName = this.selectedItem.shortName;
      this.nameItem = this.selectedItem.shortName;
      this.modalEditOpened = !this.modalEditOpened;
    },
    saveSport() {
      this.checkForm();
      if (this.validValue.form) {
        this.modalEditOpened = false;
        this.selectedItem.type = this.selectedType;
        this.$refs.SportTab.save(this.selectedItem);
      }
    }
  }
}
</script>
